var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 5c0-1.795 1.684-3.5 4-3.5s4 1.705 4 3.5zM6.5 5C6.5 2.239 9 0 12 0s5.5 2.239 5.5 5H20a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm11 1.5H20a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  })));
};
export { SvgCart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggNWMwLTEuNzk1IDEuNjg0LTMuNSA0LTMuNXM0IDEuNzA1IDQgMy41SDh6TTYuNSA1QzYuNSAyLjIzOSA5IDAgMTIgMHM1LjUgMi4yMzkgNS41IDVIMjBhMiAyIDAgMDEyIDJ2MTRhMiAyIDAgMDEtMiAySDRhMiAyIDAgMDEtMi0yVjdhMiAyIDAgMDEyLTJoMi41em0xMSAxLjVIMjBhLjUuNSAwIDAxLjUuNXYxNGEuNS41IDAgMDEtLjUuNUg0YS41LjUgMCAwMS0uNS0uNVY3YS41LjUgMCAwMS41LS41aDEzLjV6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";